import React from 'react';
import { Box, styled, Typography } from '@mui/material';

const StyledBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'gridTemplateColumns',
})<{ gridTemplateColumns: string }>(({ gridTemplateColumns }) => ({
  display: 'grid',
  gridTemplateColumns,
  maxWidth: '100%',
  padding: 14,
  alignItems: 'center',
}));

interface EqualisationsTableHeaderProps {
  headers: Array<string>;
  gridTemplateColumns: string;
}

const EqualisationsTableHeader: React.FC<EqualisationsTableHeaderProps> = ({
  headers,
  gridTemplateColumns,
}) => {
  return (
    <StyledBox gridTemplateColumns={gridTemplateColumns}>
      {headers.map((header, index) => (
        <Typography key={index} variant="h4">
          {header}
        </Typography>
      ))}
    </StyledBox>
  );
};

export default EqualisationsTableHeader;
